import { mapGetters } from "vuex";
import { store } from "@sim/store/store";
import localStorage from "@sim/services/storage";
import api from "@sim/services/api";
import SingleStep from "@sim/components/Partials/SingleStep.vue";
import StepWrapper from '@sim/components/Partials/StepWrapper.vue';
import router from "@sim/router";
import stepsMixin from '@sim/mixins/stepsMixin';
import IntlPhone from "@checkout/components/Partials/IntlPhone.vue";
import { transformErrors } from '@checkout/services/errors';

export default {
  name: "SimStep1",

  mixins: [stepsMixin],

  components: {
    SingleStep,
    StepWrapper,
    IntlPhone
  },

  data() {
    return {
      form: {
        simNumber: ""
      },
      errors: {},
      appendedClass: '',
      prefix: localStorage.get('locale', true) ? '/'+localStorage.get('locale', true) : '/de',
      showTooltip: false,
    }
  },

  computed: {
    ...mapGetters(["steps"]),
  },

  mounted() {
    localStorage.save('page-step', '1', true);

    this.prepareStep1();
  },

  methods: {
    prepareStep1() {
      api
        .get("/public-api/prepare-sim/1/" + localStorage.get("page-step", true))
        .then((response) => {
          this.form.simNumber = response.data.simNumber;
        })
        .catch((error) => {
          this.$swal(this.$i18nApi.t("messages.error"));
        });
    },

    toggleTooltip() {
      this.showTooltip = !this.showTooltip;
    },    

    proceedToNextStep() {
      store.commit("TOGGLE_PRELOADER_AXIOS_REQUEST_SCREEN_TO_TRUE");

      api
        .post("/public-api/check-sim", this.form)
        .then((response) => {
          store.commit("TOGGLE_PRELOADER_AXIOS_REQUEST_SCREEN_TO_FALSE");

          router.push(this.prefix+'/sim-registration/2');
        })
        .catch((error) => {
          store.commit("TOGGLE_PRELOADER_AXIOS_REQUEST_SCREEN_TO_FALSE");

          if (error.response.status === 422) {
            this.errors = transformErrors(error.response.data.errors);
          }

          if (error.response.data.hasOwnProperty("registered")) {
            this.$swal(this.$i18nApi.t("simRegistration.badNumber"));
          }

          if (error.response.data.hasOwnProperty("error")) {
            this.$swal(this.$i18nApi.t("messages.error"));
          } else if (error.response.status === 400) {
            this.$swal(error.response.data.message);
          }
        });
    },

  }
};
